export default __webpack_public_path__ + "static/media/silver-cube.6eddbaaa.png";